import { ClearCustomer } from './typings'

export const clearCustomerActionCreator = (): ClearCustomer => ({
  type: 'referrals/clearCustomer',
})
